import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
export function PrimaryButton({
  children,
  onClick,
  fullWidth = false,
  size = 'md',
  className = ''
}: ButtonProps) {
  const sizeClasses = {
    sm: 'py-1.5 px-3 text-sm',
    md: 'py-2 px-4 text-base',
    lg: 'py-3 px-6 text-lg'
  };
  return <button onClick={onClick} className={`
        ${fullWidth ? 'w-full' : ''}
        ${sizeClasses[size]}
        bg-[#0077BE] hover:bg-[#0066A1] 
        text-white font-bold rounded-md 
        transition-colors duration-200 
        shadow-md hover:shadow-lg
        ${className}
      `} data-id="element-111">
      {children}
    </button>;
}
export function SecondaryButton({
  children,
  onClick,
  fullWidth = false,
  size = 'md',
  className = ''
}: ButtonProps) {
  const sizeClasses = {
    sm: 'py-1.5 px-3 text-sm',
    md: 'py-2 px-4 text-base',
    lg: 'py-3 px-6 text-lg'
  };
  return <button onClick={onClick} className={`
        ${fullWidth ? 'w-full' : ''}
        ${sizeClasses[size]}
        bg-[#D4AF37] hover:bg-[#C09F2F] 
        text-[#1B365D] font-bold rounded-md 
        transition-colors duration-200 
        shadow-md hover:shadow-lg
        ${className}
      `} data-id="element-112">
      {children}
    </button>;
}
export function OutlineButton({
  children,
  onClick,
  fullWidth = false,
  size = 'md',
  className = ''
}: ButtonProps) {
  const sizeClasses = {
    sm: 'py-1.5 px-3 text-sm',
    md: 'py-2 px-4 text-base',
    lg: 'py-3 px-6 text-lg'
  };
  return <button onClick={onClick} className={`
        ${fullWidth ? 'w-full' : ''}
        ${sizeClasses[size]}
        border-2 border-[#1B365D] 
        text-[#1B365D] font-bold rounded-md 
        transition-colors duration-200 
        hover:bg-[#1B365D] hover:text-white
        ${className}
      `} data-id="element-113">
      {children}
    </button>;
}